import { render, staticRenderFns } from "./PaymentGatewayConfirm.vue?vue&type=template&id=59963a33&"
import script from "./PaymentGatewayConfirm.vue?vue&type=script&lang=ts&"
export * from "./PaymentGatewayConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});qInstall(component, 'directives', {ClosePopup});
